// @ts-expect-error module not typed
export { ThreadDetails } from '../_internal/records/ThreadDetails';